'use client'

import GridLayout from "@/app/components/Layout/GridLayout"
import Heading from "@/app/components/Elements/Heading"
import { SubmitHandler, useForm } from "react-hook-form"
import Input from "@/app/components/Form/Input"
import Textarea from "@/app/components/Form/Textarea"
import FadeIn from "@/app/components/Elements/FadeIn"
import { zodResolver } from "@hookform/resolvers/zod"
import { schema , formInputs } from "@/app/contact/schema"
import { useRouter } from 'next/navigation'
import Button from "@/app/components/Elements/Button"

const Page = () => {
    const { 
        handleSubmit,
        register,
        formState: { errors:formatError, isSubmitting, isValid },
    } = useForm<formInputs>({
        mode: "onBlur",
        resolver: zodResolver(schema),
    })

    const router = useRouter()

    const handleOnSubmit: SubmitHandler<formInputs> = async (data) => {
        const response = await fetch("/api/send",{
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                name:data.name,
                company: data.company ?? "未入力",
                email: data.email,
                tel: data.tel,
                inquiry: data.inquiry
            }),
        })
        if (response.ok) router.push('contact/thanks',{scroll:true})
    }

    return(
        <main>
            <GridLayout>
                <section className='col-span-12 mt-32'>
                    <FadeIn>
                        <Heading title='Contact' subTitle='お問い合わせ'/>
                    </FadeIn>

                    <form onSubmit={(event) => handleSubmit(handleOnSubmit)(event)} method="post" className={"grid gap-4 max-w-lg mx-auto mt-8 md:mt-16"}>
                        <FadeIn>
                            <Input type={"text"} label={"お名前"} id={"name"} required={true} autoComplete={"name"} registration={register("name")}/>
                            {formatError.name && (<div className="text-danger pl-1 pt-1 text-xs">{formatError.name.message}</div>)}
                        </FadeIn>
                        <FadeIn>
                            <Input type={"text"} label={"会社名"} id={"company"} required={false} autoComplete={"company"} registration={register("company")}/>
                            {formatError.company && (<div className="text-danger pl-1 pt-1 text-xs">{formatError.company.message}</div>)}
                        </FadeIn>
                        <FadeIn>
                            <Input type={"email"} label={"メールアドレス"} id={"email"} required={true} autoComplete={"email"} registration={register("email")}/>
                            {formatError.email && (<div className="text-danger pl-1 pt-1 text-xs">{formatError.email.message}</div>)}
                        </FadeIn>
                        <FadeIn>
                            <Input type={"tel"} label={"電話番号"} id={"tel"} required={true} autoComplete={"tel"} registration={register("tel")}/>
                            {formatError.tel && (<div className="text-danger pl-1 pt-1 text-xs">{formatError.tel.message}</div>)}
                        </FadeIn>
                        <FadeIn>
                            <Textarea label={"ご用件"} id={"inquiry"} required={true} max={100} registration={register("inquiry")}/>
                            {formatError.inquiry && (<div className="text-danger pl-1 pt-1 text-xs">{formatError.inquiry.message}</div>)}
                        </FadeIn>
                        <FadeIn>
                            <Button type={"submit"} variant={"primary"} size={"lg"} isLoading={isSubmitting} disabled={!isValid || isSubmitting} >送信</Button>
                        </FadeIn>
                    </form>
                </section>
            </GridLayout>
        </main>
        )
}

export default Page